import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { useQueryClient } from "@tanstack/react-query";
import { useAppVersionCheck } from "@/hooks/useAppVersionCheck";
import { hardReload } from "@/lib/cache-bust";

const AUTO_RELOAD_MS = 5 * 60 * 1000; // 5 minutes idle → auto reload

export function UpdatePrompt() {
  const updateAvailable = useAppVersionCheck();
  const queryClient = useQueryClient();
  const shownRef = useRef(false);

  useEffect(() => {
    if (!updateAvailable || shownRef.current) return;
    shownRef.current = true;

    const reload = () => void hardReload(queryClient);

    const autoTimer = window.setTimeout(reload, AUTO_RELOAD_MS);

    toast("Có phiên bản mới của SportRank", {
      description: "Tải lại để áp dụng cập nhật mới nhất.",
      duration: Infinity,
      action: {
        label: "Tải lại ngay",
        onClick: () => {
          clearTimeout(autoTimer);
          reload();
        },
      },
      cancel: {
        label: "Để sau",
        onClick: () => {
          // Keep autoTimer so we still reload eventually
        },
      },
    });
  }, [updateAvailable, queryClient]);

  return null;
}
